import _ from 'lodash';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import toastr from '../toastr';
import AuthService from '../../services/AuthService';
import browserHistory from '../../history';
import { changePassword, setAvatar } from '../../actions/AppActions';
import ChangePassword from './ChangePassword';
import ProfileView from './ProfileView';
import LoginPanel from '../login/LoginPanel';

const UserContainer = ({ location, match }) => {
  const dispatch = useDispatch();
  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [token] = useState(_.get(queryString.parse(location.search), 'token') || '');
  const user = useSelector(state => state.app.user);

  const clearPasswords = () => {
    setPassword('');
    setRepeatPassword('');
  };

  const handlePasswordChange = event => {
    setPassword(event.target.value);
  };

  const handlePasswordRepeatChange = event => {
    setRepeatPassword(event.target.value);
  };

  const handleSubmitPassword = event => {
    event.preventDefault();

    if (!password) {
      toastr.error('Error', 'Please enter a valid password');
      return;
    }

    if (password.length < 8) {
      toastr.error('Error', 'Password must be at least 8 characters');
      return;
    }

    if (password !== repeatPassword) {
      toastr.error('Error', 'Password and Repeat Password must match');
      return;
    }

    dispatch(changePassword(password, token))
      .then(() => {
        toastr.success('Success', 'Password has been updated');
        clearPasswords();

        if (token && !AuthService.loggedIn()) {
          browserHistory.push('/login');
        }
      })
      .catch(() => {
        toastr.error('Change Password Failed', 'Token may have expired, try to reset password again for a new one');
      });
  };

  const handleSetLogo = payload => {
    return dispatch(setAvatar(payload.userLogo.shift()));
  };

  if (token) {
    return (
      <LoginPanel>
        <ChangePassword
          password={password}
          repeatPassword={repeatPassword}
          handleSubmitPassword={handleSubmitPassword}
          handlePasswordChange={handlePasswordChange}
          handlePasswordRepeatChange={handlePasswordRepeatChange}
          includeResetLink
        />
      </LoginPanel>
    );
  }

  return (
    <ProfileView
      password={password}
      repeatPassword={repeatPassword}
      handleSubmitPassword={handleSubmitPassword}
      handlePasswordChange={handlePasswordChange}
      handlePasswordRepeatChange={handlePasswordRepeatChange}
      handleSetLogo={handleSetLogo}
      avatar={user.avatar}
      view={match.params.view}
    />
  );
};

UserContainer.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object,
};

export default UserContainer;
